<template>
  <div class="form-group">
    <label for="add1">{{ $t("address.address", [1]) | title }}</label>
    <input
      class="form-control"
      id="add1"
      name="street"
      v-model="localAddress.address_1"
      required
    />
    <label for="add2">{{ $t("address.address", [2]) | title }}</label>
    <input
      class="form-control"
      id="add2"
      name="street"
      v-model="localAddress.address_2"
    />
    <label for="city">{{ $t("address.city") | title }}</label>
    <input
      class="form-control"
      id="city"
      name="city"
      v-model="localAddress.city"
      required
    />
    <label for="country">{{ $t("address.country") | title }}</label>
    <country v-model="localAddress.country" id="country" required />
    <label for="state">{{ $t("address.state") | title }}</label>
    <state
      v-model="localAddress.state"
      id="state"
      :country="localAddress.country"
      required
    />
    <label for="zip">{{ $t("address.postal_code") | title }}</label>
    <input
      class="form-control"
      id="zip"
      name="zip"
      v-model="localAddress.zip"
      required
    />
  </div>
</template>
<script>
import State from "./State";
import Country from "./Country";
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: { State, Country },
  computed: {
    localAddress: {
      get() {
        return this.value;
      },
      set(localAddress) {
        this.$emit("input", localAddress);
      }
    }
  },
  watch: {
    localAddress: {
      handler(newVal) {
        this.$emit("input", newVal);
      },
      deep: true
    }
  }
};
</script>
